export enum LoadingStatus {
    Idle, // (fetching not started yet)
    Loading, // (currently fetching the user)
    Success, // (user fetched successfully)
    Failure, // (user failed to fetch)
}

export interface PaginationParams {
    page?: number;
    size?: number;
}

export interface PaginationMeta {
    page: number;
    size: number;
    hasNext: boolean;
    count: number;
}

export interface PaginatedList<T> {
    data: T[];
    meta: PaginationMeta;
}

export type LocaleType = 'ru' | 'en';

export interface InputData {
    name: string;
    value: string;
}

export interface CheckboxData {
    name: string;
    value: boolean;
}

export interface SelectData {
    name: string;
    value: Nullable<string>;
}

export interface SearchData {
    name: string;
    value: string;
}

export interface SelectType {
    name: string;
    value: Nullable<string>;
}

export interface InputNumberType {
    name?: string;
    originalValue?: string;
    value?: string;
    isComplete?: boolean;
}

export interface ApiErrorType<T> {
    code: string;
    message: string;
    errors?: T;
    additionalErrors: { [key: string]: string };
}

export interface RboOrganization {
    id: string;
    cnum: string;
    intName: string;
    name: string;
}

export interface RboStateProps {
    locale: LocaleType;
    apiPrefix: string;
}

export interface TokenData {
    access_token: string;
    token_type: string;
    id_token: string;
    state: string;
}

export interface QrRegisteredType {
    qrId: string;
    qrStatus: string;
    payload: string;
    qrUrl: string;
    subscriptionId: string;
}

export enum Currency {
    RUB = 'RUB',
    EUR = 'EUR',
    USD = 'USD',
}
